module.exports = __webpack_public_path__ + "img/popular-dish.81b45f73.svg";